

export const MoreInfoIcon = (props) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" fillRule="evenodd">
                <g>
                    <g>
                        <path d="M0 0L24 0 24 24 0 24z" transform="translate(-406 -961) translate(406 961)" />
                        <path  fill={props.isActive? '#3ac0a2':'#2e2744'} fillOpacity="1" fillRule="nonzero" d="M11 4h10v2H11V4zm0 4h6v2h-6V8zm0 6h10v2H11v-2zm0 4h6v2h-6v-2zM3 4h6v6H3V4zm0 10h6v6H3v-6z" transform="translate(-406 -961) translate(406 961)" />
                    </g>
                </g>
            </g>
        </svg>
    )
}